import cx from 'classnames';

/**
 * A Circular (Ring) Component
 *
 * @typedef {object} RingSpinnerProps
 * @param {string} className Optional class name
 * @param {string} color Optional color (defaulted to #000000)
 * @param {object} style CSS Properties
 * @param {object} rest Any additional props will be passed
 * @returns {JSX.Element}
 */
export const RingSpinner = ({className = '', color = '#000000', style, ...rest}) => {
  const styles = {...style, color};

  return <div className={cx('ring-spinner', className)} style={styles} {...rest} />;
};
